<section class="main-content">
  <div class="row">
    @if (linkDetails) {
      <div class="col-6">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-12">
                <div class="title-flex">
                  <h4 class="main-title">
                    <span tuiAvatar="@tui.credit-card"  class="taga-icons"></span>
                    <span class="mt-1 pad-left-10">Client-Feedback: {{linkDetails.exhibitorName}} &#64; {{linkDetails.showName}} <strong>{{soVersion}}</strong></span>
                  </h4>
                </div>
                <hr class="title-line mt-1">
              </div>
            </div>
            @if (!linkExpired && !isSuccess) {
              <div class="row mt-3">
                <div class="col-12">
                  <div class="row">
                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                      <!-- <tui-textarea [(ngModel)]="note" class="tui-space_top-4" [expandable]="true"
                        [maxLength]="510">
                        Type a Note
                        <textarea maxlength="510" tuiTextfieldLegacy></textarea>
                      </tui-textarea> -->
                      <tui-textfield  tuiTextfieldSize="m" class="tui-space_top-4">
                                <label tuiLabel>Type a Note</label>
                                <textarea [maxLength]="510"  tuiTextarea  [(ngModel)]="note"
                                  placeholder="Type a Note">
                                </textarea>
                              </tui-textfield>
                    </div>
                  </div>
                </div>
              </div>
            }
            @if (!linkExpired && !isSuccess) {
              <div class="row mt-3">
                <div class="col-12 text-center">
                  <button type="button" (click)="sendFeedback(APPROVED_KEY)" class="btn btn-success margin-right-10">
                    <i class="fas fa-check pad-right-10"></i>Approve
                  </button>
                  <button type="button" (click)="sendFeedback(NOT_APPROVED_KEY)" class="btn btn-danger margin-right-10"><i class="fas fa-times pad-right-10"></i> Not Approve</button>
                  <button type="button" (click)="sendFeedback(SENT_BACK_BY_CLIENT_KEY)" class="btn btn-secondary"><i class="fas fa-undo pad-right-10"></i>Send Back</button>
                </div>
              </div>
            }
            @if (linkExpired && !isSuccess && linkDetails) {
              <div class="row mt-3">
                <div class="col-12">
                  <h6>Status: @if (linkDetails.linkStatusKey === APPROVED_KEY) {
                    <strong class="success-color">{{linkDetails.linkStatus}}</strong>
                  }
                  @if (linkDetails.linkStatusKey !== APPROVED_KEY) {
                    <strong class="warning-color">{{linkDetails.linkStatus}}</strong>
                  }</h6>
                </div>
                @if (linkDetails.linkStatusKey !== APPROVED_KEY) {
                  <div class="col-12">
                    <h6>Comment: {{linkDetails.comment}}</h6>
                  </div>
                }
                <!-- <div class="col-12">
                <div class="alert alert-outline mt-2" role="alert">
                  <div class="warning-color">
                    {{message}}
                  </div>
                </div>
              </div> -->
            </div>
          }
          @if (!linkExpired && isSuccess) {
            <div class="row mt-3">
              <div class="col-12">
                <div class="alert alert-outline mt-2" role="alert">
                  <div class="success-color">
                    SO Status updated successfully.
                  </div>
                </div>
              </div>
            </div>
          }
        </div>
      </div>
    </div>
  }
</div>
</section>